import { render, staticRenderFns } from "./ContratosDataTable.vue?vue&type=template&id=596a4e20&scoped=true"
import script from "./ContratosDataTable.vue?vue&type=script&lang=ts"
export * from "./ContratosDataTable.vue?vue&type=script&lang=ts"
import style0 from "./ContratosDataTable.vue?vue&type=style&index=0&id=596a4e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a4e20",
  null
  
)

export default component.exports